import { render } from "./PermissionsTable.vue?vue&type=template&id=e9e111a2&scoped=true"
import script from "./PermissionsTable.vue?vue&type=script&lang=js"
export * from "./PermissionsTable.vue?vue&type=script&lang=js"

import "./PermissionsTable.vue?vue&type=style&index=0&id=e9e111a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9e111a2"]])

export default __exports__